import { reactive, toRefs } from 'vue'

export default function usePagination(callback, options = { page_size: 15 }) {
    const pagenation = reactive({
        page: 1,
        page_size: options.page_size,
        handleSizeChange: (size) => {
            if (!size) return
            pagenation.page = 1
            pagenation.page_size = size
            callback && callback()
        },
        handleCurrentChange: (currentPage) => {
            if (!currentPage) return
            pagenation.page = currentPage
            callback && callback()
        }
    })

    const handleSizeChange = pagenation.handleSizeChange
    const handleCurrentChange = pagenation.handleCurrentChange
    const { page, page_size } = toRefs(pagenation)

    return { handleSizeChange, handleCurrentChange, page, page_size }
}
